/**
 * Copyright (c) Microsoft. All rights reserved.
 */

export const constants = {
    TROUTER_INIT: 'trouterinit',
    TROUTER_READY_EVENT: 'trouterReadyEvent',
    TROUTER_READY_TIMEOUT: 'trouterReadyTimeout',
    TROUTER_TOKEN_REQUEST: 'trouterTokenRequest',
    TROUTER_TOKEN_GET_SUCCEEDED: 'trouterTokenGetSucceeded',
    TROUTER_TOKEN_GET_FAILED: 'trouterTokenGetFailed',
    TROUTER_RECONNECTING: 'trouterReconnecting',
    RENEWAL: 'renewal',
    NEW_CONNECTION: 'newConnection',
    ENDPOINT_REGISTRATION_FAILED: 'endpointRegistrationFailed'
};

export const CLIENT_VERSION: string = '2024.14.01.55';
export const HANDLED_MESSAGE_ACK = 200;
export const UNHANDLED_MESSAGE_ACK = 404;
export const FAILED_MESSAGE_ACK = 500;
export const SUPPORTED_TOKEN_TYPES = <const>['skype', 'aad', 'cae'];
export const USER_AUTHENTICATE_EVENT_NAME = 'user.authenticate';



// WEBPACK FOOTER //
// ./lib_temp/Constants.ts